<template>
  <div>
    <!-- NonAttendanceDescription -->
    <b-form-group
      label="Motivo do não atendimento"
      label-for="NonAttendanceReasonId"
    >
      
      <b-form-select
      :options="optionsNonAttendance"
      v-model="model.nonAttendanceReasonId"
      :disabled="readonly"
    >
    </b-form-select>
    
      <span class="text-danger" v-if="modelstate['NonAttendanceReasonId']">
        {{ modelstate["NonAttendanceReasonId"][0] }}
      </span>
    </b-form-group>

    <div>
      <b-form-group
      label="Observação do não atendimento"
      label-for="NonAttendanceDescription"
    >
      <b-form-textarea
        id="NonAttendanceDescription"
        placeholder="Motivo do não atendimento"
        v-model="model.nonAttendanceDescription"
        :readonly="readonly"
      />
      </b-form-group>
      <span class="text-danger" v-if="modelstate['NonAttendanceDescription']">
        {{ modelstate["NonAttendanceDescription"][0] }}
      </span>
    </div>
    
  </div>

</template>

<script>
import AwesomeMask from "awesome-mask";

export default {
  name: "CargoCrudStatusNonAttendance",
  directives: {
    mask: AwesomeMask,
  },
  props: {
    model: Object,
    modelstate: Object,
    nonAttendanceReason: String,
    readonly: Boolean,
  },
  data() {
    return {
      optionsNonAttendance: [{ value: null, text: "Carregando motivos de nao atendimento" }],
    };
  },
  computed: {
    
      getUrlNonAttendance() {
        return `v1/nonAttendanceReason/dropdownOptions`;
      }
  },
  created() {
    this.loadNonAttendanceReason();
  },
  
  methods:{
    loadNonAttendanceReason() {
      this.$api
        .get(this.getUrlNonAttendance)
        .then((response) => {
          this.optionsNonAttendance = response.data;
          this.$forceUpdate();
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.alert.error = error.message;
            this.$refs.danger.show();
          }
        });
    },
  }
};
</script>
